import {ISickDay} from '@app/core/interfaces/sick-days.interface';
import {Pagination} from '@app/core/models/pagination.model';

export interface ISickDaysState {
	sickDays: ISickDay[];
	isLoading: boolean;
	isLoadingAnswers: boolean;
	answers: any[];
	pagination: Pagination;
}

export const initialSickDaysState: ISickDaysState = {
	sickDays: [],
	answers: [],
	isLoading: false,
	isLoadingAnswers: false,
	pagination: undefined,
};
